import Cost from '../dto/Cost';
import Error from '../model/Error';
import axios from 'axios';

window.careCostsCache = null;
window.deferredPromises = [];

export default class CostRepository {
    static findAllByKindergarten(kindergartenId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/kindergartens/${kindergartenId}/costs`)
                .then((response) => resolve(response.data.data.map((data) => Cost.fromData(data))))
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }
}
